module.exports = __webpack_public_path__ + "img/video_heart.c8e2e334.svg";